// extracted by mini-css-extract-plugin
module.exports = {"root":"double-line-module--root--2aOD4","title":"double-line-module--title--3rrdQ","second":"double-line-module--second--1HJqx","subtitle":"double-line-module--subtitle--1uuKM"};